module.exports = __webpack_public_path__ + "img/news-nav-icon-1.31bd6f84.png";